import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink } from "react-router-dom";
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";

function Leavecontrolpanel() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const navigate = useNavigate();
    const Swal = require('sweetalert2')
    const [branches, setBranches] = useState([]);
    const [selectedBranchCode, setSelectedBranchCode] = useState('');
    const [leavePolicies, setLeavePolicies] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);

    const [selectedLeavePolicy, setSelectedLeavePolicy] = useState('');
    const [leavePolicyDetails, setLeavePolicyDetails] = useState(null); 


    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [carryForward, setCarryForward] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [filteredStaff, setFilteredStaff] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const [isFilterOpenadv, setIsFilterOpenadv] = useState(false);
    const [isDepartmentDropdownOpen, setIsDepartmentDropdownOpen] = useState(false);
    const departmentDropdownRef = useRef(null);

    const departmentSelectorStyles = {
        wrapper: {
            position: "relative"
        },
        trigger: {
            minHeight: "38px",
            border: "1px solid #ced4da",
            borderRadius: "4px",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            cursor: "pointer"
        },
        triggerText: {
            fontSize: "0.95rem",
            color: "#495057",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingRight: "10px"
        },
        dropdown: {
            position: "absolute",
            top: "calc(100% + 6px)",
            left: 0,
            right: 0,
            zIndex: 20,
            border: "1px solid #ced4da",
            borderRadius: "4px",
            backgroundColor: "#fff",
            boxShadow: "0 8px 18px rgba(31, 45, 61, 0.12)",
            overflow: "hidden"
        },
        list: {
            maxHeight: "180px",
            overflowY: "auto",
            padding: "6px"
        },
        item: {
            display: "flex",
            alignItems: "flex-start",
            gap: "8px",
            padding: "6px 10px",
            marginBottom: "4px",
            borderRadius: "2px",
            cursor: "pointer"
        },
        checkbox: {
            marginTop: "2px",
            width: "14px",
            height: "14px",
            accentColor: "#2f5bea",
            flexShrink: 0
        },
        label: {
            marginBottom: 0,
            fontSize: "0.92rem",
            fontWeight: 400,
            color: "#2f3b52",
            lineHeight: "1.2",
            wordBreak: "break-word"
        }
    };

    const getDepartmentTriggerText = () => {
        if (selectedDepartments.length === 0) {
            return "Select Department";
        }

        if (selectedDepartments.length === departments.length && departments.length > 0) {
            return "All Departments Selected";
        }

        return departments
            .filter((dept) => selectedDepartments.includes(String(dept.dept_id)))
            .map((dept) => dept.dept_name)
            .join(", ");
    };

    const handleSelectAllDepartments = (e) => {
        if (e.target.checked) {
            setSelectedDepartments(departments.map((dept) => String(dept.dept_id)));
            return;
        }

        setSelectedDepartments([]);
    };

    const handleDepartmentCheckboxChange = (deptId) => {
        setSelectedDepartments((prev) =>
            prev.includes(String(deptId))
                ? prev.filter((id) => id !== String(deptId))
                : [...prev, String(deptId)]
        );
    };

    const getStaffDepartmentName = (staff) => {
        if (staff.dept_name || staff.department_name || staff.staff_department_name) {
            return staff.dept_name || staff.department_name || staff.staff_department_name;
        }

        const matchedDepartment = departments.find(
            (dept) => String(dept.dept_id) === String(staff.staff_department || staff.dept_id)
        );

        return matchedDepartment?.dept_name || "-";
    };

    const getLeavePoliciesByBranch = (branchId) => {
        if (!branchId) {
            setLeavePolicies([]);
            return;
        }

        axios.get(`${baseurladdress}findleavepolicytest/${branchId}`, {
            headers: { Authorization: `Bearer ${accesstoken}` }
        })
            .then(res => setLeavePolicies(res.data.response || []))
            .catch(() => setLeavePolicies([]));
    };

    useEffect(() => {
        axios.get(`${baseurladdress}findallbranches`, { headers: { Authorization: `Bearer ${accesstoken}` } })
            .then(res => setBranches(res.data.response));
        axios.get(`${baseurladdress}findalldept`, { headers: { Authorization: `Bearer ${accesstoken}` } })
            .then(res => setDepartments(res.data.response));
        axios.get(`${baseurladdress}findallstaff`, { headers: { Authorization: `Bearer ${accesstoken}` } })
            .then(res => setStaffList(res.data.response));
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (departmentDropdownRef.current && !departmentDropdownRef.current.contains(event.target)) {
                setIsDepartmentDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLeavePolicySelect = (policyNum) => {
        setSelectedLeavePolicy(policyNum);
        if (!policyNum) {
            setLeavePolicyDetails(null);
            return;
        }
        axios.get(`${baseurladdress}getleavepolicybypolicynum/${policyNum}`, {
            headers: { Authorization: `Bearer ${accesstoken}` }
        })
            .then(res => setLeavePolicyDetails(res.data.response));
    };

    const toggleQuickFilter = () => {
        setIsFilterOpen(!isFilterOpen);
        setIsFilterOpenadv(false); 
        setSearchQuery("");
        setFilteredStaff([]);
    };
    const toggleAdvancedFilter = () => {
        setIsFilterOpenadv(!isFilterOpenadv);
        setIsFilterOpen(false); 
        setSelectedDepartments([]);
        setFilteredStaff([]);
    };

    const handleQuickFilterSearch = () => {
        if (!selectedBranchCode || selectedDepartments.length === 0) {
            return alert("Please choose branch and at least one department.");
        }

        const results = staffList
            .filter((staff) => String(staff.staff_placedat) === String(selectedBranchCode))
            .filter((staff) => selectedDepartments.includes(String(staff.staff_department || staff.dept_id)));

        setFilteredStaff(results);
    };
    const clearQuickFilter = () => {
        setSelectedDepartments([]);
        setIsDepartmentDropdownOpen(false);
        setIsFilterOpen(false);
        setFilteredStaff([]);
    };

    useEffect(() => {
        if (isFilterOpenadv && selectedBranchCode && searchQuery.trim()) {
            const results = staffList
                .filter(staff => String(staff.staff_placedat) === String(selectedBranchCode))
                .filter(staff => staff.staff_name.toLowerCase().includes(searchQuery.toLowerCase()));
            setFilteredStaff(results);
        } else if (isFilterOpenadv) {
            setFilteredStaff([]);
        }
    }, [searchQuery, staffList, selectedBranchCode, isFilterOpenadv]);
    const clearAdvancedFilter = () => {
        setSearchQuery("");
        setIsFilterOpenadv(false);
        setFilteredStaff([]);
    };

    // ✅ Updated allocation logic
    // const handleAllocateLeave = async () => {
      
    //     if (!fromDate || !selectedBranchCode || !selectedLeavePolicy) {
    //         Swal.fire({
    //             toast: true,
    //             position: "top-end",
    //             icon: "error",
    //             title: "Please fill in all required fields.",
    //             showConfirmButton: false,
    //             timer: 2000,
    //             timerProgressBar: true,
    //         });
    //         return;
    //     }
    //     if (filteredStaff.length === 0 && selectedEmployees.length === 0) {
    //         Swal.fire({
    //             toast: true,
    //             position: "top-end",
    //             icon: "error",
    //             title: "Please select or filter at least one employee.",
    //             showConfirmButton: false,
    //             timer: 2000,
    //             timerProgressBar: true,
    //         });
    //         return;
    //     }

    //     try {
    //         const branch = branches.find((b) => b.branch_id === Number(selectedBranchCode));
    //         const selectedDepartmentObjects = departments.filter((d) =>
    //             selectedDepartments.includes(String(d.dept_id))
    //         );
    //         const leaveTypes = Array.isArray(leavePolicyDetails)
    //             ? leavePolicyDetails.map((policy) => ({
    //                 id: policy.leavepolicy_leavetypeid,
    //                 name: policy.leavepolicy_leavetype.trim(),
    //                 maxleave: policy.leavepolicy_leavealloted,
    //                 policy_id: policy.leavepolicy_id,
    //             }))
    //             : [];

    //         const selectedDepartmentIds = selectedDepartmentObjects
    //             .map((dept) => dept.dept_id)
    //             .join(",");

    //         const selectedDepartmentNames = selectedDepartmentObjects
    //             .map((dept) => dept.dept_name)
    //             .join(", ");

        
    //         const employeesToAllocate = selectedEmployees.length > 0
    //             ? staffList.filter((s) => selectedEmployees.includes(s.staff_id))
    //             : filteredStaff;


    //         const payload = {
    //             from_date: fromDate,
    //             to_date: toDate,
    //             userid: accessuserid,
    //             applied_leaves:"",
    //             pending_leaves:"",
    //             carry_forward: carryForward ? 1 : 0,
    //             branch: { id: branch.branch_id, name: branch.branch_name },
    //             leave_policy: { num: selectedLeavePolicy, leave_types: leaveTypes },
    //             leaveassign_dpid: selectedDepartmentIds,
    //             leaveassign_dptname: selectedDepartmentNames,
    //             department: {
    //                 id: selectedDepartmentIds,
    //                 name: selectedDepartmentNames
    //             },
    //             employees: employeesToAllocate,
    //         };

    //         const response = await axios.post(`${baseurladdress}assignleave`, payload, {
    //             headers: { Authorization: `Bearer ${accesstoken}` },
    //         });

    //         const result = response.data; 
    //         if (result.status === "success") {
    //             Swal.fire({
    //                 toast: true,
    //                 position: "top-end",
    //                 icon: "success",
    //                 title: "Leave allocated successfully!",
    //                 showConfirmButton: false,
    //                 timer: 1500,
    //                 timerProgressBar: true,
    //             });
    //             navigate("/leaveassignmentlist");
    //         } else {
    //             Swal.fire({
    //                 toast: true,
    //                 position: "top-end",
    //                 icon: "error",
    //                 title: `Error: ${result.message}`,
    //                 showConfirmButton: false,
    //                 timer: 2000,
    //                 timerProgressBar: true,
    //             });
    //         }
    //     } catch (error) {
    //         Swal.fire({
    //             toast: true,
    //             position: "top-end",
    //             icon: "error",
    //             title: `Submit Failed: ${error.message}`,
    //             showConfirmButton: false,
    //             timer: 2000,
    //             timerProgressBar: true,
    //         });
    //     }
    // };
// UPDATED handleAllocateLeave FUNCTION ONLY
// Replace your existing handleAllocateLeave function with this

const handleAllocateLeave = async () => {

    if (!fromDate || !selectedBranchCode || !selectedLeavePolicy) {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Please fill in all required fields.",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        return;
    }

    if (filteredStaff.length === 0 && selectedEmployees.length === 0) {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Please select or filter at least one employee.",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
        });
        return;
    }

    try {

        // BRANCH
        const branch = branches.find(
            (b) => b.branch_id === Number(selectedBranchCode)
        );

        // LEAVE TYPES
        const leaveTypes = Array.isArray(leavePolicyDetails)
            ? leavePolicyDetails.map((policy) => ({
                id: policy.leavepolicy_leavetypeid,
                name: policy.leavepolicy_leavetype.trim(),
                maxleave: policy.leavepolicy_leavealloted,
                policy_id: policy.leavepolicy_id,
            }))
            : [];

        // EMPLOYEES
        const employeesToAllocate = selectedEmployees.length > 0
            ? staffList.filter((s) =>
                selectedEmployees.includes(s.staff_id)
            )
            : filteredStaff;

        // Normalize employees with explicit department info.
        // Department filter is only for finding staff quickly; assignment saves employee's own department.
        const normalizedEmployees = employeesToAllocate
            .map((emp) => {
                const deptId = emp.staff_department || emp.dept_id || "";
                const deptName =
                    emp.dept_name ||
                    emp.department_name ||
                    emp.staff_department_name ||
                    getStaffDepartmentName(emp) ||
                    "";

                return {
                    staff_id: emp.staff_id,
                    staff_name: emp.staff_name,
                    staff_email: emp.staff_email,
                    dept_id: deptId,
                    dept_name: deptName,
                };
            })
            .filter((emp) => emp.staff_id && emp.staff_name && emp.dept_id && emp.dept_name);

        if (normalizedEmployees.length === 0) {
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "Selected staff do not have valid department mapping.",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
            return;
        }

        const payload = {
            from_date: fromDate,
            to_date: toDate,
            userid: accessuserid,

            applied_leaves: "",
            pending_leaves: "",

            carry_forward: carryForward ? 1 : 0,

            branch: {
                id: branch.branch_id,
                name: branch.branch_name,
            },

            leave_policy: {
                num: selectedLeavePolicy,
                leave_types: leaveTypes,
            },

            // Optional filter context (not used for save mapping).
            selected_department_ids: selectedDepartments,
            employees: normalizedEmployees,
        };

        console.log("PAYLOAD", payload);

        const response = await axios.post(
            `${baseurladdress}assignleave`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        );

        const result = response.data;

        if (result.status === "success") {

            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Leave allocated successfully!",
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
            });

            navigate("/leaveassignmentlist");

        } else {

            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: `Error: ${result.message}`,
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            });
        }

    } catch (error) {

        console.log(error);

        Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: `Submit Failed`,
            text: error?.response?.data?.message || error.message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    }
};
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <NavLink activeClassName="active-link" to={"/leaveassignmentlist"}>
                            <div style={{ display: "flex" }}>
                                <a className="float">
                                    <i className="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                                </a>
                            </div>
                        </NavLink>


                        <section id="main-content">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <h6 className="card-title">Leave Control Panel</h6>
                                    <button className="btn btn-primary" onClick={handleAllocateLeave}>Allocate Leave</button>
                                </div>
                                <div className="card-body">
                                   
                                    <div className="row mb-3">
                                        <div className="col-sm-6">
                                            <h6>From Date</h6>
                                            <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                            <h6 className="mt-3">To Date</h6>
                                            <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                            <div className="mt-3">
                                                <input type="checkbox" checked={carryForward} onChange={(e) => setCarryForward(e.target.checked)} /> Carry Forward
                                                <div style={{ fontSize: "smaller" }}>Add unused leaves from previous leave period's allocation to this allocation</div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <h6>Branch</h6>
                                            <select
                                                className="form-control"
                                                value={selectedBranchCode}
                                                onChange={e => {
                                                    const branchId = e.target.value;
                                                    setSelectedBranchCode(branchId);
                                                    setSelectedLeavePolicy('');
                                                    setLeavePolicyDetails(null);
                                                    setSelectedDepartments([]);
                                                    setIsDepartmentDropdownOpen(false);
                                                    setFilteredStaff([]);
                                                    setSelectedEmployees([]);
                                                    getLeavePoliciesByBranch(branchId);
                                                }}
                                            >
                                                <option value="">Choose</option>
                                                {branches.map(b => <option key={b.branch_id} value={b.branch_id}>{b.branch_name}</option>)}
                                            </select>
                                        </div>
                                        <div className="col-sm-3">
                                            <h6>Leave Policy</h6>
                                            <select
                                                className="form-control"
                                                value={selectedLeavePolicy}
                                                onChange={e => handleLeavePolicySelect(e.target.value)}
                                            >
                                                <option value="">Choose Leave Policy</option>
                                                {leavePolicies.map(p => (
                                                    <option key={p.leavepolicy_num} value={p.leavepolicy_num}>
                                                        {p.leavepolicy_num}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Quick Filter */}
                                    <div className="col-sm-12 mt-2">
                                        <button className="btn btn-link p-0" onClick={toggleQuickFilter}>Quick Filters <i className={`fa ${isFilterOpen ? "fa-angle-up" : "fa-angle-down"}`}></i></button>
                                        {isFilterOpen && (
                                            <div className="my-3 form-row">
                                                <div className="form-group col-4">
                                                    <h6>Department</h6>
                                                    <div style={departmentSelectorStyles.wrapper} ref={departmentDropdownRef}>
                                                        <div
                                                            style={departmentSelectorStyles.trigger}
                                                            onClick={() => setIsDepartmentDropdownOpen((prev) => !prev)}
                                                        >
                                                            <span style={departmentSelectorStyles.triggerText}>
                                                                {getDepartmentTriggerText()}
                                                            </span>
                                                            <i className={`fa ${isDepartmentDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                                                        </div>

                                                        {isDepartmentDropdownOpen && (
                                                            <div style={departmentSelectorStyles.dropdown}>
                                                                <div style={departmentSelectorStyles.list}>
                                                                    <label
                                                                        htmlFor="select-all-departments"
                                                                        style={{
                                                                            ...departmentSelectorStyles.item,
                                                                            backgroundColor: departments.length > 0 && selectedDepartments.length === departments.length ? "#edf3ff" : "#f8faff",
                                                                            border: departments.length > 0 && selectedDepartments.length === departments.length ? "1px solid #bfd2ff" : "1px solid #edf1f7"
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            id="select-all-departments"
                                                                            checked={departments.length > 0 && selectedDepartments.length === departments.length}
                                                                            onChange={handleSelectAllDepartments}
                                                                            style={departmentSelectorStyles.checkbox}
                                                                        />
                                                                        <span style={{ ...departmentSelectorStyles.label, fontWeight: 700 }}>
                                                                            Select All Departments
                                                                        </span>
                                                                    </label>

                                                                    {departments.map((dept) => {
                                                                        const isChecked = selectedDepartments.includes(String(dept.dept_id));

                                                                        return (
                                                                            <label
                                                                                htmlFor={`department-${dept.dept_id}`}
                                                                                key={dept.dept_id}
                                                                                style={{
                                                                                    ...departmentSelectorStyles.item,
                                                                                    backgroundColor: isChecked ? "#edf3ff" : "#ffffff",
                                                                                    border: isChecked ? "1px solid #bfd2ff" : "1px solid #edf1f7"
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`department-${dept.dept_id}`}
                                                                                    checked={isChecked}
                                                                                    onChange={() => handleDepartmentCheckboxChange(dept.dept_id)}
                                                                                    style={departmentSelectorStyles.checkbox}
                                                                                />
                                                                                <span style={departmentSelectorStyles.label}>
                                                                                    {dept.dept_name}
                                                                                </span>
                                                                            </label>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group col-2 mt-4">
                                                    <button className="btn btn-primary" onClick={handleQuickFilterSearch}>Search</button>
                                                </div>
                                                <div className="form-group col-2 mt-4">
                                                    <button className="btn btn-outline-secondary" onClick={clearQuickFilter}>Clear</button>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Advanced Filter */}
                                    <div className="col-sm-12 mt-2">
                                        <button className="btn btn-link p-0" onClick={toggleAdvancedFilter}>Advanced Filters <i className={`fa ${isFilterOpenadv ? "fa-angle-up" : "fa-angle-down"}`}></i></button>
                                        {isFilterOpenadv && (
                                            <div className="my-3 form-row">
                                                <div className="form-group col-4">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by staff name"
                                                        value={searchQuery}
                                                        onChange={e => setSearchQuery(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group col-2 mt-1">
                                                    <button className="btn btn-outline-secondary" onClick={clearAdvancedFilter}>Clear</button>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Staff Table */}
                                    <div className="col-sm-12 card mt-3">
                                        <div className="card-header"><h5>Select Employees</h5></div>
                                        <div className="card-body">
                                            <table className="table table-bordered">
                                                <thead>
    <tr>
        <th>
            <input
                type="checkbox"
                checked={
                    filteredStaff.length > 0 &&
                    selectedEmployees.length === filteredStaff.length
                }
                onChange={(e) => {
                    if (e.target.checked) {
                        // Select all staff IDs
                        const allIds = filteredStaff.map(staff => staff.staff_id);
                        setSelectedEmployees(allIds);
                    } else {
                        // Unselect all
                        setSelectedEmployees([]);
                    }
                }}
            />
        </th>
        <th>Name</th>
        <th>Email</th>
        <th>Department</th>
    </tr>
</thead>
                                                <tbody>
                                                    {filteredStaff.length > 0 ? filteredStaff.map(staff => (
                                                        <tr key={staff.staff_id}>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedEmployees.includes(staff.staff_id)}
                                                                    onChange={e => {
                                                                        const updated = e.target.checked
                                                                            ? [...selectedEmployees, staff.staff_id]
                                                                            : selectedEmployees.filter(id => id !== staff.staff_id);
                                                                        setSelectedEmployees(updated);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{staff.staff_name}</td>
                                                            <td>{staff.staff_email}</td>
                                                            <td>{getStaffDepartmentName(staff)}</td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td colSpan="4" className="text-center text-muted">No staff found.</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default Leavecontrolpanel;
